// Dependencies
import React, { PropsWithChildren } from "react";

import { Grid, GridCol } from "../Grid";
import Spacer from "../Spacer";
// Components
import Text from "../Text";
// Styles
import css from "./Admin.module.scss";

interface AdminContainerProps {
	className?: string;
}

export const AdminContainer = ({ className = "", children }: PropsWithChildren<AdminContainerProps>) => {
	return (
		<section className={`${css.adminSection}`}>
			<Spacer height={4} />
			<Grid cols={1} padding={2}>
				<GridCol span={1}>
					<div className={`${className || css.content}`}>{children}</div>
				</GridCol>
			</Grid>
		</section>
	);
};

interface AdminTitleProps {
	includeSpacer?: boolean;
	description?: string;
}

export const AdminTitle = (props: PropsWithChildren<AdminTitleProps>) => {
	const { description = null } = props;

	return (
		<div>
			<Text element="h2" size="heading-5" weight="semi-bold" className={`${css.adminTitle}`} color="neutral-9">
				{props.children}
			</Text>
			{description ? (
				<>
					<Spacer height={1} />
					<Text size="paragraph-3" weight="regular" color="neutral-5" className={css.adminDescription}>
						{description}
					</Text>
				</>
			) : null}
			<Spacer height={2} />
		</div>
	);
};
